module.exports = __webpack_public_path__ + "static/media/buddiez.5a9b31c5.jpg";